import { Transformation, TransformationType } from 'shared/types/transformation';
import { Validator } from 'shared/components/MultiStepForm/types';

const validator: Validator<Transformation> = (values) => {
  if (!values[TransformationType.INDICATOR_TYPE]?.length) {
    return 'Select at least one indicator type to continue.';
  }

  if (!values[TransformationType.SCORE_FILTERING]?.length) {
    return 'Select at least one score to continue.';
  }
};

export default validator;
